export const sortByAlphabet = (a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' });
